import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const campaign = useLocation().pathname.replace(/\/$/, '') === '/emergencia';
  if (campaign) return (
    <footer className="bg-segredo-black text-white pb-28 md:pb-0">
      <div className="container mx-auto px-6 py-10 flex flex-col gap-5 text-center">
        <strong className="text-xl font-serif">Chaveiro Serralheiro</strong>
        <p className="text-gray-400 text-sm">Lisboa · Cascais · Sintra · Margem Sul</p>
        <a href="tel:+351965715768" className="text-segredo-yellow font-bold">965 715 768</a>
        <div className="flex flex-wrap justify-center gap-5 text-xs text-gray-400">
          <Link to="/politica-privacidade">Política de Privacidade</Link>
          <Link to="/politica-cookies">Política de Cookies</Link>
              <button type="button" onClick={() => window.dispatchEvent(new Event('open-cookie-preferences'))} className="hover:text-segredo-yellow transition-colors underline py-2">Preferências de cookies</button>
          <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer">Livro de Reclamações</a>
        </div>
      </div>
    </footer>
  );
  return (
    <footer className="bg-segredo-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>

            <h3 className="text-2xl font-serif font-bold text-white mb-6">Chaveiro Serralheiro</h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              Serviços de chaveiro e serralheiro urgente em Lisboa. Abertura de portas, mudança de fechaduras e sistemas de segurança com rapidez e profissionalismo.
            </p>

          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-segredo-yellow transition-colors text-sm cursor-pointer">Home</Link></li>
              <li><Link to="/sobre" className="text-gray-400 hover:text-segredo-yellow transition-colors text-sm cursor-pointer">Sobre nós</Link></li>
              <li><Link to="/contato" className="text-gray-400 hover:text-segredo-yellow transition-colors text-sm cursor-pointer">Contactos</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Serviços</h3>
            <ul className="space-y-2">
              <li><Link to="/abertura-portas" className="text-gray-400 hover:text-segredo-yellow transition-colors text-sm cursor-pointer">Abertura de Portas</Link></li>
              <li><Link to="/mudanca-fechaduras" className="text-gray-400 hover:text-segredo-yellow transition-colors text-sm cursor-pointer">Mudança de Fechaduras</Link></li>
              <li><Link to="/reparacao-fechaduras" className="text-gray-400 hover:text-segredo-yellow transition-colors text-sm cursor-pointer">Reparação de Fechaduras</Link></li>
              <li><Link to="/instalacao-mola" className="text-gray-400 hover:text-segredo-yellow transition-colors text-sm cursor-pointer">Instalação de Molas</Link></li>
              <li><Link to="/trinco-eletricos" className="text-gray-400 hover:text-segredo-yellow transition-colors text-sm cursor-pointer">Trinco Elétrico</Link></li>
              <li><Link to="/cilindros-porta-blindada" className="text-gray-400 hover:text-segredo-yellow transition-colors text-sm cursor-pointer">Portas Blindadas</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contactos</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-phone-line text-segredo-yellow mt-0.5"></i>
                <a href="tel:+351965715768" className="text-gray-400 hover:text-segredo-yellow transition-colors cursor-pointer">965 715 768</a>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-mail-line text-segredo-yellow mt-0.5"></i>
                <a href="mailto:geralchaveirolx@gmail.com" className="text-gray-400 hover:text-segredo-yellow transition-colors cursor-pointer">geralchaveirolx@gmail.com</a>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-time-line text-segredo-yellow mt-0.5"></i>
                <span className="text-gray-400">Atendimento 24h</span>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-map-pin-line text-segredo-yellow mt-0.5"></i>
                <span className="text-gray-400">Lisboa e Arredores</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-4">
            <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-xs text-gray-400">
              <Link to="/politica-privacidade" className="hover:text-segredo-yellow transition-colors cursor-pointer whitespace-nowrap">Política de Privacidade</Link>
              <Link to="/politica-cookies" className="hover:text-segredo-yellow transition-colors cursor-pointer whitespace-nowrap">Política de Cookies</Link>
              <button type="button" onClick={() => window.dispatchEvent(new Event('open-cookie-preferences'))} className="hover:text-segredo-yellow transition-colors underline py-2">Preferências de cookies</button>
              <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer" className="hover:text-segredo-yellow transition-colors cursor-pointer whitespace-nowrap">Livro de Reclamações</a>
              <Link to="/areas-atendimento" className="hover:text-segredo-yellow transition-colors cursor-pointer whitespace-nowrap">Áreas de Atendimento</Link>
            </div>
            <span className="text-xs text-gray-400">
              Site desenvolvido por <a href="https://api.whatsapp.com/send/?phone=351938602478&text=Ol%C3%A1%2C%20tenho%20interesse%20em%20criar%20um%20site&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="hover:text-segredo-yellow transition-colors cursor-pointer">Foture Marketing</a>
            </span>
          </div>



          <div className="border-t border-gray-800 mt-16 pt-8 text-center text-gray-500 text-sm">
            <p>&copy; {new Date().getFullYear()} Chaveiro Serralheiro. Todos os direitos reservados.</p>
            <p className="mt-2 text-sm">
              Site desenvolvido por <a href="https://api.whatsapp.com/send/?phone=351938602478&text=Ol%C3%A1%2C%20tenho%20interesse%20em%20criar%20um%20site&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="text-segredo-yellow hover:text-white transition-colors">Foture Marketing</a>
            </p>
          </div>
        </div>
      </div >
    </footer >
  );
}
